import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23445 23445"
    {...props}
  >
    <circle
      cx={11722}
      cy={11722}
      r={10919}
      style={{
        fill: "none",
        stroke: "#2b2a29",
        strokeWidth: 1605.81,
      }}
      className="stroke1"
    />
    <circle
      cx={11722}
      cy={11722}
      r={2409}
      style={{
        fill: "#2b2a29",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
